module.exports = __webpack_public_path__ + "img/maslahat-3.2e8b3d4c.png";